// @flow

import type { YoutubeVideo, YoutubeVideoPlayer } from 'types/YoutubeVideo';

export const FETCH_VIDEO_PLAYER_START = 'FETCH_VIDEO_PLAYER_START';
export const FETCH_VIDEO_PLAYER_SUCCESS = 'FETCH_VIDEO_PLAYER_SUCCESS';
export const FETCH_VIDEO_PLAYER_FAILURE = 'FETCH_VIDEO_PLAYER_FAILURE';

export type FETCH_VIDEO_PLAYER_START_ACTION = {
  type: 'FETCH_VIDEO_PLAYER_START',
  payload: { idVideo: string }
};

export type FETCH_VIDEO_PLAYER_FAILURE_ACTION = {
  type: 'FETCH_VIDEO_PLAYER_FAILURE'
};

export type FETCH_VIDEO_PLAYER_SUCCESS_ACTION = {
  type: 'FETCH_VIDEO_PLAYER_SUCCESS',
  payload: {
    video: YoutubeVideoPlayer,
    suggestedVideos: Array<YoutubeVideo>
  }
};

export type Action =
  | FETCH_VIDEO_PLAYER_START_ACTION
  | FETCH_VIDEO_PLAYER_FAILURE_ACTION
  | FETCH_VIDEO_PLAYER_SUCCESS_ACTION;

export function fetchVideoPlayer(idVideo: string): FETCH_VIDEO_PLAYER_START_ACTION {
  return {
    type: FETCH_VIDEO_PLAYER_START,
    payload: { idVideo }
  };
}

export function videoPlayerFetched(
  video: YoutubeVideoPlayer,
  suggestedVideos: Array<YoutubeVideo>
): FETCH_VIDEO_PLAYER_SUCCESS_ACTION {
  return {
    type: FETCH_VIDEO_PLAYER_SUCCESS,
    payload: { video, suggestedVideos }
  };
}

export function videoPlayerFetchError(error: any): FETCH_VIDEO_PLAYER_FAILURE_ACTION {
  return {
    type: FETCH_VIDEO_PLAYER_FAILURE
  };
}
